
























import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: ['propertyName'],
  data(): {
    boxplotChartOptions: ApexOptions;
    boxplotSeries: [{ data: Array<{ x: string; y: Array<number> }> }];
    columnChartOptions: ApexOptions;
    columnSeries: any;
  } {
    const labelAnalysisResult =
      this.$store.getters.labelAnalysisResult[this.propertyName];
    const boxplot = labelAnalysisResult.array_count_boxplot;

    const countInfo = {
      maxLength: labelAnalysisResult.max_length,
      minLength: labelAnalysisResult.min_length,
      meanLength: labelAnalysisResult.mean_length.toFixed(2),
    };

    return {
      boxplotChartOptions: {
        chart: {
          toolbar: {
            show: true,
            tools: {
              selection: false,
              zoom: false,
              zoomout: false,
              zoomin: false,
              pan: false,
              reset: false,
            },
          },
          width: '100%',
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#5BD99C'],
        xaxis: {
          position: 'bottom',
          labels: {
            show: true,
          },
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'right',
          fontSize: '12px',
          show: true,
          inverseOrder: true,
        },
        stroke: {
          show: true,
          colors: ['#323C47'],
          width: 0.5,
        },
        plotOptions: {
          boxPlot: {
            colors: {
              upper: '#5BD99C',
              lower: '#FF974D',
            },
          },
        },
      },
      boxplotSeries: [
        {
          data: [
            {
              x: ``,
              y: [
                boxplot.min,
                boxplot.lower_qt,
                boxplot.median,
                boxplot.upper_qt,
                boxplot.max,
              ],
            },
          ],
        },
      ],
      columnChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '200%',
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          categories: ['', '개수', ''],
        },
        dataLabels: {
          formatter: function (val) {
            return val === 0 ? '' : val.toString();
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val === 0 ? '' : val + '개';
            },
          },
        },
      },
      columnSeries: [
        {
          name: '최소',
          data: [0, countInfo.minLength, 0],
        },
        { name: '평균', data: [0, countInfo.meanLength, 0] },
        {
          name: '최대',
          data: [0, countInfo.maxLength, 0],
        },
      ],
    };
  },
  computed: {},
});
